import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {WidgetNotificacionComponent} from './widget-notificacion.component';
import {GLMMaterialDesignModule} from '../material-design/material-design.module';
import { WidgetNotificacionService } from './widget-notificacion.service';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    GLMMaterialDesignModule,
    ReactiveFormsModule
  ],
  exports: [WidgetNotificacionComponent],
  declarations: [WidgetNotificacionComponent],
  providers: [WidgetNotificacionService],
})
export class WidgetNotificacionModule {
}
